import { FileText, ShoppingCartSimple, ShoppingCart, X } from '@phosphor-icons/react';
import { Form, FormInstance } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import {
  ChoicePayment,
  ConfirmationModal,
  LayoutTwoColComponent,
  showAlertNotification,
  StepComponent,
} from 'components/common';
import { SupplierOrderCart, SupplierOrderInfor, SupplierOrderList } from 'components/SupplierOrder';
// import SupllierPaymentConfirm from 'components/SupplierOrder/SupllierPaymentConfirm/SupllierPaymentConfirm';
import dayjs from 'dayjs';
import { InventoryDocumentType, PaymentType, Product } from 'models';
import { TransactionMethodCode } from 'models/TransactionMethod';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  useCheckUniqueMutation,
  useCreateAttachmentMutation,
  useCreateOrderSupplierMutation,
  useGetAllAttachmentTypesQuery,
  useGetAllTransactionMethodsQuery,
  useGetAllWarehousesQuery,
  useGetProductsQuery,
  useGetStatusQuery,
  useGetSuppliersQuery,
} from 'services';
import useAuthContext from 'stores/auth-context';
import { useCart } from 'stores/cartContext';
import { FileData, QueryParams, StatusOrderSupplierCode, TableEnum } from 'types';
import { useBarcodeUtils } from 'utils';

const steps = [
  { title: 'Chọn Sản Phẩm', icon: <ShoppingCartSimple size={20} /> },
  { title: 'Nhập Thông Tin Đơn Hàng Và Thanh Toán', icon: <FileText size={20} /> },
];

const CreatOrderSupplier: React.FC = () => {
  const [form] = Form.useForm();
  const { profile } = useAuthContext();
  const [checkValueEmpty, setCheckValueEmpty] = useState<boolean>(false);
  const onPrevStepRef = useRef<() => void | undefined>(undefined);
  const location = useLocation();
  const [customAmount, setCustomAmount] = useState<number>(0);
  const { cartItems, clearCart } = useCart();
  const currentStepRef = useRef<number>(0);
  const { id } = useParams<{ id: string }>();
  const supplierId: string = (location.state as { supplierId?: string })?.supplierId || (id ?? '');
  const [selectedSupplierId, setSelectedSupplierId] = useState<string | number | undefined>(supplierId);
  const [selectedVAT, setSelectedVAT] = useState<number>(0);
  const [createAttachment] = useCreateAttachmentMutation();

  const isDesktop = false; // useMediaQuery({ query: '(min-width: 1024px)' });
  const [isCartPanelVisible, setIsCartPanelVisible] = useState(false);

  const [isLoadingDraff, setIsLoadingDraff] = useState<boolean>(false);
  const [selectedMethod, setSelectedMethod] = useState<PaymentType>(PaymentType.FULL_PAYMENT);
  const [createOrderSupplier, { isLoading }] = useCreateOrderSupplierMutation();
  const [transactionAttachments, setTransactionAttachments] = useState<FileData[]>([]);

  const navigate = useNavigate();
  const { data: statuses } = useGetStatusQuery({
    query: { filter: 'type:eq:order-supplier' },
  });
  const [checkUnique, { isLoading: isCheckingUnique }] = useCheckUniqueMutation();
  const draftPaymentId = statuses?.data?.find((item) => item.name === StatusOrderSupplierCode.DRAFT_PAYMENT)?.id;
  const ConfirmId = statuses?.data?.find((item) => item.name === StatusOrderSupplierCode.PAID)?.id;
  const { handleCreateCode, handleBarcode } = useBarcodeUtils({
    form,
    code: 'OS',
  });
  const { data: transactionMethodsData } = useGetAllTransactionMethodsQuery({
    query: {
      size: 'unlimited',
    },
  });
  const toggleCartPanel = () => {
    setIsCartPanelVisible((prev) => !prev);
  };
  const { data: attachmentTypes } = useGetAllAttachmentTypesQuery({
    query: {
      size: 'unlimited',
    },
  });
  const { data } = useGetProductsQuery({
    query: {
      size: 'unlimited',
      include:
        'product.productVersions|category|brand|currencyUnit|baseUnit|productImages.image|product.productSuppliers',
      filter: 'isActive:eq:true',
      sort: 'updatedAt:desc',
      // supplierId: selectedSupplierId,
    } as QueryParams,
  });
  const { data: suppliers } = useGetSuppliersQuery({
    query: {
      include: 'baseUser',
      size: 'unlimited',
    },
  });
  const { data: warehouses } = useGetAllWarehousesQuery({
    query: {
      size: 'unlimited',
    },
  });
  const wareHouseId = useMemo(() => warehouses?.data.rows[0].id, [warehouses]);
  let totalQuantity = 0;
  let totalPrice = 0;
  const cartList: Product[] = cartItems
    .map((item) => {
      const product = data?.data?.rows.find((p) => p.id === item.productId);
      if (product) {
        totalQuantity += item.quantity;
        totalPrice += (Number(item.costPrice) ?? 0) * item.quantity;
        return {
          ...product,
          quantityBuy: item.quantity,
          costPrice: Number(item.costPrice) || 0,
          salePrice: Number(item.salePrice) || 0,
        } as Product;
      }
      return null;
    })
    .filter((p): p is Product => p !== null);
  const createOrderPayload = useCallback(
    (
      form: FormInstance,
      cartList: Product[],
      subTotal: number,
      isPublishing: boolean,
      selectedMethod?: PaymentType,
      currentStep?: number,
      transactionMethod?: TransactionMethodCode,
    ) => {
      return {
        isPublishing: isPublishing,
        code: form.getFieldValue('code'),
        barcode: form.getFieldValue('barcode'),
        deliveryDate: form.getFieldValue('deliveryDate'),
        receivedDate: null,
        total: subTotal,
        currentStep: currentStep,
        supplierId: selectedSupplierId as string,
        description: form.getFieldValue('describeOrder'),
        note: form.getFieldValue('describeNote'),
        userName: form.getFieldValue('userName'),
        userPhoneNumber: form.getFieldValue('phoneNumber'),
        userEmail: form.getFieldValue('email'),
        statusId: isPublishing ? ConfirmId || '' : draftPaymentId || '',
        warehouseId: form.getFieldValue('warehouse'),
        paymentType: selectedMethod,
        createdBy: null,
        type: InventoryDocumentType.ORDER_SUPPLIER,
        inventoryDocumentId: null,
        items: [],
        payInAdvance: isPublishing ? Number(customAmount) : 0,
        paidMoney: 1,
        unpaidMoney: 1,
        vat: selectedVAT,
        transaction: isPublishing
          ? {
              transactionMethodId: transactionMethodsData?.data.rows.filter(
                (method) => method.code === transactionMethod,
              )?.[0].id,
              transactionAmount: isPublishing ? Number(customAmount) : 0,
              transactionAttachments: transactionAttachments.map((file) => ({
                attachmentId: file.id || '',
                description: 'transaction attachment order supplier',
              })),
              ownerType: 'SUPPLIER',
            }
          : undefined,
        inventoryDocumentItems: cartList.map((item) => ({
          name: item.name,
          category: item.category?.name,
          brand: item.brand?.name,
          productDimension: item.dimension,
          sizeSpec: item.sizeSpec,
          color: item.color,
          unitId: item.baseUnitId,
          unitConvertValue: 1,
          unit: item.baseUnit?.name,
          productVersionId: item.id,
          quantity: item.quantityBuy ?? 0,
          costPrice: Number(item.costPrice) ?? 0,
          salePrice: Number(item.salePrice) ?? 0,
          total: (item.costPrice ?? 0) * (item.quantityBuy ?? 0),
        })),
      };
    },
    [ConfirmId, draftPaymentId, wareHouseId, customAmount, transactionAttachments, selectedVAT],
  );

  const handleSubmit = useCallback(
    async (
      subTotal: number,
      transactionMethod: TransactionMethodCode,
      selectedMethod: PaymentType,
      currentStep: number,
    ) => {
      if (totalQuantity <= 0) {
        showAlertNotification({
          type: 'error',
          title: 'Chưa thêm sản phẩm',
          message: 'Vui lòng thêm ít nhất 1 sản phẩm.',
        });
        return false;
      }
      try {
        const payload = createOrderPayload(
          form,
          cartList,
          subTotal,
          true,
          selectedMethod,
          currentStep,
          transactionMethod,
        );
        checkUnique({
          table: TableEnum.InventoryDocuments,
          field: 'code',
          value: payload.code || '',
        }).then((response) => {
          if (response?.data?.data.exists) {
            form.setFields([
              {
                name: 'code',
                errors: [`Mã đơn hàng "${payload.code}" đã tồn tại. Vui lòng sử dụng mã khác.`],
              },
            ]);
            showAlertNotification({
              type: 'warning',
              title: 'Thông báo',
              message: `Mã đơn hàng "${payload.code}" đã tồn tại. Vui lòng sử dụng mã khác.`,
            });
            return;
          }
        });
        checkUnique({
          table: TableEnum.InventoryDocuments,
          field: 'barcode',
          value: payload.barcode || '',
        }).then((response) => {
          if (response?.data?.data.exists) {
            form.setFields([
              {
                name: 'barcode',
                errors: [`Mã vạch "${payload.barcode}" đã tồn tại. Vui lòng sử dụng mã khác.`],
              },
            ]);
            showAlertNotification({
              type: 'warning',
              title: 'Thông báo',
              message: `Mã vạch "${payload.barcode}" đã tồn tại. Vui lòng sử dụng mã khác.`,
            });
            return;
          }
        });
        console.log(payload);
        const res = await createOrderSupplier(payload).unwrap();
        clearCart();
        navigate(`/management/inventory/supplier-orders/payment-wait/${res.data.id}`, {
          state: { orderSupplierId: res.data.id },
        });
        showAlertNotification({
          type: 'success',
          title: 'Tạo đơn hàng thành công',
          message: `Bạn đã tạo đơn hàng thành công`,
        });
      } catch (error) {
        showAlertNotification({
          type: 'error',
          title: 'Tạo đơn hàng thất bại',
          message: typeof error === 'string' ? error : error instanceof Error ? error.message : 'Đã xảy ra lỗi',
        });
        console.error('Error creating order:', error);
      }
    },
    [cartList, createOrderSupplier, form, clearCart, createOrderPayload, navigate, totalQuantity],
  );

  const wrappedHandlers = {
    confirmDelete: () => {
      onPrevStepRef.current?.();
      setCheckValueEmpty(false);
    },
  };
  const handleSaveDraff = useCallback(
    async (totalPrice: number, selectedMethod: PaymentType, currentStep: number) => {
      setIsLoadingDraff(true);
      if (totalQuantity <= 0) {
        showAlertNotification({
          type: 'error',
          title: 'Chưa thêm sản phẩm',
          message: 'Vui lòng thêm ít nhất 1 sản phẩm.',
        });
        return false;
      }
      const total = Number(form.getFieldValue('totalPrice') || totalPrice);
      try {
        const payload = createOrderPayload(form, cartList, total, false, selectedMethod, currentStep);
        checkUnique({
          table: TableEnum.InventoryDocuments,
          field: 'code',
          value: payload.code || '',
        }).then((response) => {
          if (response?.data?.data.exists) {
            form.setFields([
              {
                name: 'code',
                errors: [`Mã đơn hàng "${payload.code}" đã tồn tại. Vui lòng sử dụng mã khác.`],
              },
            ]);
            showAlertNotification({
              type: 'warning',
              title: 'Thông báo',
              message: `Mã đơn hàng "${payload.code}" đã tồn tại. Vui lòng sử dụng mã khác.`,
            });
            setIsLoadingDraff(false);
            return;
          }
        });
        await createOrderSupplier(payload).unwrap();
        showAlertNotification({
          type: 'success',
          title: 'Tạo đơn hàng thành công',
          message: `Bạn đã lưu đơn nháp thành công`,
        });
        setIsLoadingDraff(false);
        clearCart();
        navigate('/management/inventory/supplier-orders?newChange=true');
        return;
      } catch (error) {
        console.error('Error creating order:', error);
        setIsLoadingDraff(false);
        showAlertNotification({
          type: 'error',
          title: 'Tạo đơn hàng thất bại',
          message: `Bạn  lưu đơn nháp thất bại`,
        });
      }
    },
    [form, clearCart, createOrderPayload, navigate, cartList, createOrderSupplier, totalQuantity],
  );
  const handleNextStep = useCallback((): boolean => {
    if (totalQuantity <= 0) {
      showAlertNotification({
        type: 'error',
        title: 'Chưa thêm sản phẩm',
        message: 'Vui lòng thêm ít nhất 1 sản phẩm.',
      });
      return false;
    }
    return true;
  }, [totalQuantity]);
  useEffect(() => {
    const init = async () => {
      form.setFieldValue('warehouse', wareHouseId);

      if (profile) {
        form.setFieldValue('userName', profile?.data?.baseUser?.name);
        form.setFieldValue('email', profile?.data?.baseUser?.email);
        form.setFieldValue('phoneNumber', profile?.data?.baseUser?.phoneNumber);
      }
      if (supplierId) {
        const supplier = suppliers?.data?.rows?.find((item) => item.id === supplierId);
        if (supplier) {
          setSelectedSupplierId(supplier.id);
          form.setFieldValue('supplierName', supplier.baseUser.name);
          form.setFieldValue('supplierId', supplier.id);
          form.setFieldValue('supplierEmail', supplier.baseUser?.email);
          form.setFieldValue('supplierPhoneNumber', supplier.baseUser?.phoneNumber);
          form.setFieldValue('supplierAddress', supplier.baseUser?.address);
        }
      }
      form.setFieldValue('deliveryDate', dayjs());
      await handleCreateCode();
      handleBarcode();
    };
    init();
  }, [handleCreateCode, handleBarcode, form, profile, supplierId, suppliers?.data?.rows, navigate, wareHouseId]);
  const warehouse = useWatch('warehouse', form);
  useEffect(() => {
    if (warehouse) {
      console.log('Selected warehouse:', warehouse);
      form.setFieldValue('warehouseName', warehouses?.data?.rows?.find((item) => item.id === warehouse)?.name);
    }
  }, [warehouse]);
  useEffect(() => {
    if (selectedSupplierId) {
      const supplier = suppliers?.data?.rows?.find((item) => item.id === selectedSupplierId);
      if (supplier) {
        form.setFieldValue('supplierName', supplier.baseUser.name);
        form.setFieldValue('supplierId', supplier.id);
        form.setFieldValue('supplierEmail', supplier.baseUser?.email);
        form.setFieldValue('supplierPhoneNumber', supplier.baseUser?.phoneNumber);
        form.setFieldValue('supplierAddress', supplier.baseUser?.address);
      }
    }
  }, [selectedSupplierId]);
  const handleUpload = useCallback(
    async (files: File[]): Promise<void> => {
      try {
        for (const file of files) {
          const attachment = await createAttachment({
            name: 'Transaction Attachment ' + new Date().toISOString(),
            filePath: file.name,
            attachmentTypeId: attachmentTypes?.data?.rows.filter((type) => type.code === 'transaction')[0]?.id || '',
          }).unwrap();
          setTransactionAttachments((prev) => [
            ...prev,
            {
              id: attachment.data.id,
              filePath: attachment.data.filePath,
              order: prev.length + 1,
              name: file.name,
            },
          ]);
        }
      } catch (error) {
        console.error('Error uploading files:', error);
        showAlertNotification({
          type: 'error',
          title: 'Lỗi tải lên tệp',
          message: 'Đã xảy ra lỗi khi tải lên tệp. Vui lòng thử lại.',
        });
      }
    },
    [createAttachment, attachmentTypes],
  );
  const renderRightComponent = () => {
    if (isDesktop && currentStepRef.current !== 1) {
      return null;
    }

    if (currentStepRef.current === 1) {
      return (
        <ChoicePayment
          onSubmit={handleSubmit}
          cartList={cartList}
          form={form}
          subTotal={totalPrice}
          totalQuantity={totalQuantity}
          customAmount={customAmount}
          setCustomAmount={setCustomAmount}
          selectedMethod={selectedMethod}
          setSelectedMethod={setSelectedMethod}
          isLoading={isLoading || isLoadingDraff || isCheckingUnique}
          selectedVAT={selectedVAT}
          setSelectedVAT={setSelectedVAT}
          classname=' xl:max-w-[444px] max-w-[400px] bg-white'
          handleUploadExcel={handleUpload}
        />
      );
    }

    return null;
  };

  return (
    <>
      <StepComponent
        steps={steps}
        form={form}
        beforePrevStep={async () => {
          if (currentStepRef.current === 1 && !checkValueEmpty) {
            setCheckValueEmpty(true);
            return false;
          }
          return true;
        }}
      >
        {({ currentStep, onNextStep, onPrevStep }) => {
          currentStepRef.current = currentStep;
          const renderLeftComponent = () => {
            onPrevStepRef.current = onPrevStep;
            switch (currentStep) {
              case 0:
                return (
                  <SupplierOrderList
                    selectedSupplierId={selectedSupplierId}
                    setSelectedSupplierId={setSelectedSupplierId}
                    form={form}
                  />
                );
              case 1:
                return (
                  <>
                    <SupplierOrderInfor
                      form={form}
                      selectedSupplierId={selectedSupplierId}
                      setSelectedSupplierId={setSelectedSupplierId}
                      handleBarcode={handleBarcode}
                      handleCreatecode={handleCreateCode}
                    />
                    <ConfirmationModal
                      isOpen={checkValueEmpty}
                      onCancel={() => setCheckValueEmpty(false)}
                      onConfirm={wrappedHandlers.confirmDelete}
                      title='Thông tin chưa được lưu'
                      subtitle={<div>Thông tin có thể sẽ bị mất!</div>}
                      icon='warning'
                      confirmText='Đồng ý'
                    />
                  </>
                );
              // case 2:
              //   return (
              //     <>
              //       <SupllierPaymentConfirm
              //         form={form}
              //         selectedSupplierId={selectedSupplierId}
              //         handleBarcode={handleBarcode}
              //         handleCreatecode={handleCreateCode}
              //       />
              //     </>
              //   );
              default:
                return null;
            }
          };

          return (
            <>
              <LayoutTwoColComponent
                stickyTop={56}
                // showStep={false}
                showStep={false}
                currentStep={currentStep}
                onNextStep={
                  currentStep < 1
                    ? () => {
                        if (handleNextStep()) {
                          onNextStep();
                        }
                      }
                    : undefined
                }
                onPrevStep={onPrevStep}
                form={form}
                isLoading={isLoadingDraff}
                steps={steps}
                onSaveDraft={
                  currentStep > 1 ? () => handleSaveDraff(totalPrice, selectedMethod, currentStep) : undefined
                }
                left={<div className='  mt-2'>{renderLeftComponent()}</div>}
                right={renderRightComponent()}
                rightClassName={` mt-2 min-h-max ${currentStepRef.current === 0 ? 'max-w-[0px] ' : ' xl:max-w-[444px] max-w-[400px]'}`}
                leftClassName={` overflow-x-hidden`}
              />
            </>
          );
        }}
      </StepComponent>

      {!isDesktop && currentStepRef.current !== 2 && (
        <div className='fixed bottom-6 right-6 z-40 cursor-pointer' onClick={toggleCartPanel}>
          <div className='bg-[var(--primaryColor500)] text-white rounded-full w-16 h-16 flex items-center justify-center shadow-lg'>
            <ShoppingCart size={28} weight='fill' />
            {cartItems && cartItems.length > 0 && (
              <div className='absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold'>
                {cartItems.length}
              </div>
            )}
          </div>
        </div>
      )}

      {!isDesktop && currentStepRef.current !== 2 && (
        <div className={`fixed inset-0 z-50 flex justify-end ${isCartPanelVisible ? 'visible' : 'invisible'}`}>
          <div
            className={`absolute inset-0 bg-black transition-opacity duration-300 ${
              isCartPanelVisible ? 'opacity-50' : 'opacity-0'
            }`}
            onClick={() => setIsCartPanelVisible(false)}
          ></div>

          <div
            className={`relative bg-white min-w-[500px] flex flex-col max-w-[550px] h-full transform transition-transform duration-300 ease-out shadow-xl overflow-auto ${
              isCartPanelVisible ? 'translate-x-0' : 'translate-x-full'
            }`}
          >
            <div className='sticky top-0 bg-white p-4 border-b border-gray-200 flex items-center justify-between z-10'>
              <div className='text-lg font-bold'></div>
              <button
                className='text-gray-500 hover:text-gray-700 focus:outline-none'
                onClick={() => setIsCartPanelVisible(false)}
              >
                <X size={24} />
              </button>
            </div>
            <div className='p-4 flex-1'>
              <SupplierOrderCart products={cartList} totalQuantity={totalQuantity} totalPrice={totalPrice} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreatOrderSupplier;
